export const PROFANITY_WORDS = [
  'fuck',
  'shit',
  'bitch',
  'asshole',
  'сука',
  'блять',
  'блядь',
  'хуй',
  'пизда',
  'пиздец',
  'ебать',
  'йоб',
  'нахуй',
  'мудак',
];

